import React, { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ModalsSelectors, MeSelectors } from '../../../redux/selectors';
import { AsyncActionStatus } from '../../../redux/enums';
import { MeActionCreators } from '../../../redux/actions/creators';
import DefaultModal from '../DefaultModal';
import { UserRole, UserInteractions } from '../../../../../shared/enums';

const FeatureInfoModal = ({
  ChatBot: () => {
    const dispatch = useDispatch();

    const me = useSelector(MeSelectors.selectMe);
    const isChatBotInfoModalOpen = useSelector(ModalsSelectors.selectChatBotInfoModalIsOpen);
    const isShownModal = useMemo(() => (
      isChatBotInfoModalOpen
       && ([UserRole.CUSTOMER].includes(me.role))
      //  && ([UserRole.CUSTOMER, UserRole.WRITER].includes(me.role))
    ), [isChatBotInfoModalOpen, me.role]);

    const updateUserInteraction = useCallback(() => {
      dispatch(MeActionCreators.updateUserInteractions[AsyncActionStatus.PENDING](
        me._id,
        UserInteractions.SeenChatbot,
      ));
    }, [dispatch, me._id]);

    return (
      <DefaultModal
        isShown={isShownModal}
        closeModal={updateUserInteraction}
        primaryAction={updateUserInteraction}
        title={t(`featureInfoModal.chatbot.${me.role}.title`, { ns: i18next.Namespace.COMMON })}
        message={t(`featureInfoModal.chatbot.${me.role}.message`, { ns: i18next.Namespace.COMMON })}
        primaryBtnText={t('button.ok', { ns: i18next.Namespace.COMMON })}
      />
    );
  },
});

export default FeatureInfoModal;
